var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.275 20c7.552 0 11.682-6.157 11.682-11.493 0-.176 0-.352-.009-.52A8.338 8.338 0 0022 5.893a8.44 8.44 0 01-2.358.637 4.05 4.05 0 001.805-2.237 8.398 8.398 0 01-2.606.98A4.117 4.117 0 0015.844 4C13.58 4 11.74 5.81 11.74 8.038c0 .318.034.628.111.921a11.711 11.711 0 01-8.463-4.222 4.002 4.002 0 00-.554 2.027c0 1.4.724 2.64 1.831 3.36a4.084 4.084 0 01-1.856-.503v.05c0 1.96 1.413 3.586 3.295 3.963a4.153 4.153 0 01-1.856.066c.52 1.609 2.035 2.773 3.831 2.807A8.34 8.34 0 012 18.174 11.574 11.574 0 008.275 20z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.727cafbba080cf88c1c8bcb1540ab786.svg";